module.exports = __webpack_public_path__ + "img/cross.8db7ae2f.svg";